jQuery(function ($) {
    $('.rotate-btn').on('click', function () {
        $(this).closest('.card').toggleClass('flipped');
    });
    $(window).on('load', function () {
        var $rotatingCards = $('.card-rotating');
        $rotatingCards.each(function () {
            var $this = $(this);
            var $cardWrapper = $this.parent();
            var $front = $this.find('.front');
            var $back = $this.find('.back');
            var $frontHeight = $this.find('.front').outerHeight();
            var $backHeight = $this.find('.back').outerHeight();
            if ($frontHeight > $backHeight) {
                // @ts-ignore
                $($cardWrapper, $back).height($frontHeight);
            } else if ($frontHeight < $backHeight) {
                // @ts-ignore
                $($cardWrapper, $front).height($backHeight);
            } else {
                $($cardWrapper).height($backHeight);
            }
        });
    });
    $('.card-share > a').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('share-expanded').parent().find('div').toggleClass('social-reveal-active');
    });
    $('.map-card').on('click', function () {
        $(this).find('.card-body').toggleClass('closed');
    });
});
